<template>
    <v-text-field v-model="value" @input="changeValue" class="text-field-item mb-1" dense outlined hide-details />
</template>
<script>
export default {
    props: ["classificator_value", "classificator_row", "classificator_type"],
    name: "classificator-input",
    data() {
        return { value: this.classificator_value };
    },
    methods: {
        changeValue(val) {
            this.$emit("changeValue", {
                value: val,
                classificator_row: this.classificator_row,
                classificator_type: this.classificator_type
            });
        }
    }
};
</script>
<style scoped>
.text-field-item {
    border-color: gray;
}
</style>
